import {
  SuiClient,
  SuiTransactionBlockResponse,
} from '@mysten/sui/client';
import { SUI_TYPE_ARG } from '@mysten/sui/utils';
const suiEndPoint = 'https://fullnode.mainnet.sui.io:443';
export const SUI_TOKEN_ADDRESS = SUI_TYPE_ARG;
let suiClient: SuiClient = new SuiClient({ url: suiEndPoint });
export const suiScanUrl = 'https://suiscan.xyz/mainnet/tx/';
export const mockSuiEvmChainId = 784;
export function getSuiClient(): SuiClient {
  if (suiClient) {
    return suiClient;
  }
  const client = new SuiClient({ url: suiEndPoint });
  suiClient = client;
  return suiClient;
}

export const sendSuiTx = async ({
  bytes,
  signature,
}: {
  bytes: Uint8Array;
  signature: string;
}): Promise<SuiTransactionBlockResponse> => {
  const res = await suiClient.executeTransactionBlock({
    transactionBlock: bytes,
    signature: signature,
  });
  return res;
};

// only form send
export interface GetSuiSendGasType {
  fromAddress: string;
  toAddress: string;
  amount: string;
  coinType?: string;
}